var _ = require('underscore');

module.exports = function (env) {
    var staticPath = '/static/';

    if (typeof window !== 'undefined') {
        staticPath = window.app.settings.staticUrl;
    };

    env.addGlobal('isMobile', function () {
        return window.app.settings.isMobile;
    });

    env.addGlobal('isPhone', function () {
        return window.app.settings.isPhone;
    });

    env.addGlobal('isTablet', function () {
        return window.app.settings.isTablet;
    });

    env.addGlobal('isDesktop', function () {
        return window.app.settings.isDesktop;
    });

    env.addGlobal('static', function (file) {
        return staticPath + file;
    }, true);
};



//////////////////
// WEBPACK FOOTER
// ./nunjucks.config.js
// module id = 6
// module chunks = 0